// Address errors are shown by the single Shipping Address section, not per input.
const FIELD_ALIASES: Record<string, string> = {
  street: "address",
  city: "address",
  state: "address",
  zip: "address",
};

/**
 * Scrolls the checkout dialog to the first (top-most) section that has a validation error.
 * Sections opt in with a `data-error-field="<errors key>"` attribute.
 */
export function scrollToFirstError(errors: Record<string, string>) {
  const fields = new Set(Object.keys(errors).map((key) => FIELD_ALIASES[key] ?? key));
  if (fields.size === 0) return;

  // Wait for the error messages to render so the layout is final before scrolling.
  nextTick(() => {
    const target = Array.from(document.querySelectorAll<HTMLElement>("[data-error-field]")).find(
      (el) => fields.has(el.dataset.errorField!) && el.getClientRects().length > 0
    );
    if (!target) return;

    const isTall = target.getBoundingClientRect().height > window.innerHeight * 0.6;
    target.scrollIntoView({ behavior: "smooth", block: isTall ? "start" : "center" });
  });
}
